/**
 * Mixins provide common hooks to share across all components.
 * Reference:
 * https://vuejs.org/v2/guide/mixins.html
 *
 * common.js just define hooks that are to be globally accessed.
 */

import * as i18n from '@js/i18n';

export const common = {
    methods: {
        /**
         * Set main website data and cate.
         * Notice that if used in beforeRouteUpdate (i.e. component router guard), we need to pass the vm instance to access to 'this'
         * @param data
         * @param vueInstance
         */
        setWebSiteAndCate(data, vueInstance) {

            vueInstance.$store.commit('cate/setCateItem', data.maincate);
            vueInstance.$store.commit('mainSite/setLogo', data.subject_logo);
            vueInstance.$store.commit('mainSite/setMobileLogo', data.website_mobile_logo);
            vueInstance.$store.commit('mainSite/setRelationLang', data.relation_language);
            vueInstance.$store.commit('mainSite/setRelation', data.relation);
            vueInstance.$store.commit('mainSite/setTheme', data.theme);
            document.title = data.title;
            document.querySelector("link[rel*='icon']").href = data.website_logo;
            document.querySelector("meta[name='description']").content = data.meta_description;
            document.querySelector("meta[name='keywords']").content = data.meta_keywords;
            document.querySelector("meta[property='og:title']").content = data.og_title;
            document.querySelector("meta[property='og:url']").content = data.og_url;
            document.querySelector("meta[property='og:description']").content = data.og_description;

            //TODO: consider passing protocol...
            if (this.storeMainSite) {
                var token = "";
                if (access_token) {
                    token += "?access_token=" + access_token;
                }
                var url = "http://" + this.storeMainSite.relation + "." + window.urlData.domain;
                this.$store.commit('mainSite/setRelationURL', url + token);
                this.$store.commit('mainSite/setDefaultRelationURL', url);

            }
        },
        encodeFilename(filename) {
            return encodeURIComponent(filename)
        },
        formatSize(bytes) {
            var thresh = 1024;
            if (Math.abs(bytes) < thresh) {
                return bytes + ' B';
            }
            var units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            var u = -1;
            do {
                bytes /= thresh;
                ++u;
            } while (Math.abs(bytes) >= thresh && u < units.length - 1);
            return bytes.toFixed(1) + ' ' + units[u];
        },
        formatToUpperCase(string) {
            if (typeof string === 'string') {
                return string.toUpperCase();
            } else {
                string = "";
            }

            return string;
        },
        /**
         * When mobile menu closes, or browser breakpoint changes when resizing, reset the mainApp size;
         */
        resetMainAppSize() {
            window.scrollTo(0, 0);
            document.querySelector('#app').style.overflowY = 'auto';
        },
        /**
         * parse getText from i18n
         * @param msgStr
         * @param getTextParams
         * @returns {*}
         */
        lang(msgStr, getTextParams) {
            if (getTextParams) {
                Object.keys(getTextParams).forEach(key => {
                    msgStr = msgStr.replace(new RegExp(`%${key}%`, "g"), getTextParams[key]);
                });

                return msgStr;

            } else {
                return msgStr;
            }
        },
        /**
         * 當用戶進入subcate 時, 更新 右上角的中英文版的連結
         */
        updateRelationUrl(current_subcate_id) {

            let self = this;
            //update relation lang url
            var url = this["mainSite/getDefaultRelationURL"];
            var token = (access_token !== undefined) ? "?access_token=" + access_token : "";
            var updated = false;

            if (this.storeCate.cateItem) {
                this.storeCate.cateItem.forEach(function (maincate_obj) {
                    if (maincate_obj.subcate.length > 0) {
                        maincate_obj.subcate.forEach(function (subcate_obj) {

                            if (subcate_obj.id === current_subcate_id && subcate_obj.relation_url !== "") {
                                url = subcate_obj.relation_url + token;
                                updated = true;
                            }
                        });
                    }
                });
            }

            if (updated) {
                this.$store.commit('mainSite/setRelationURL', url);

            } else {
                this.$store.commit('mainSite/setRelationURL', url + token);

            }

        },
        /**
         * 檢查是否已經登入
         * @return {boolean}
         */
        checkIsLoggedIn() {
            if (access_token !== null) {
                return true;
            } else {
                return false;

            }

        },
        /**
         * get name by role
         * @param role
         */
        getUserRole(role) {
            var name = "";

            switch (role) {
                case "SDNT":
                    name = "Student";
                    break;
                case "SLAM":
                    name = "School Admin";
                    break;
                case "GENL":
                    name = "General User";
                    break;
                case "TCHR":
                    name = "Teacher";
                    break;
                case "SYSA":
                    name = "System Admin";
                    break;
                default:
                    break;

            }

            return name;
        },

        getParameterByName(name, url) {
            if (!url) {
                url = window.location.href;
            }
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        },
        /**
         * 檢查用戶是否 使用IOS devices
         * @return {boolean}
         */
        checkIsIOS() {
            var iDevices = [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ];

            if (!!navigator.platform) {
                while (iDevices.length) {
                    if (navigator.platform === iDevices.pop()) { return true; }
                }
            }

            if (navigator.platform === 'MacIntel') {
                return true;
            }

            return false;
        },
        checkIsAndroid() {
            var ua = navigator.userAgent.toLowerCase();
            var isAndroid = ua.indexOf("android") > -1;

            if (isAndroid) {

                return true;
            }

            return false;
        },
        checkIOSVersion() {
            if (/iP(hone|od|ad)/.test(navigator.platform)) {
                // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
                var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
                return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
            }

            if (navigator.platform === 'MacIntel') {
                return [13];
            }

            return false;
        },
        checkIsSafari() {
            if (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) {

                return true;
            }

            return false;
        },
        checkIsMobile() {
            let check = false;
            (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        },
        /**
         *
         * @param arr_data
         * @param objkey
         * @param mime_type
         * @return {*}
         */
        getResourceContentData(arr_data, objkey, mime_type) {
            let value = null;
            if (!arr_data.content) {
                return value
            }
            arr_data.content.filter(item => {
                if (item.key === objkey) {
                    value = item.value;
                }
            });

            if (objkey === 'hkepc:technical/format') {
                if (value) {
                    value = mime_type[value];
                }

            }

            return value;

        },
        /**
         * return orignal formation value
         * @param arr_data
         */
        getResourceFormat(arr_data) {
            let value = null;

            arr_data.content.filter(item => {
                if (item.key === 'hkepc:technical/format') {
                    value = item.value;
                }
            });

            return value;
        },
        getResourceId(metadata_id) {
            // Extract 02_Pri2edHB_P9A_pdf from hkep-lom:02_Pri2edHB_P9A_pdf/Final/0.4
            var match = metadata_id.match(/:(.*?)(?=\/)/);

            if (match) {
                return match[1];
            } else {
                return '';
            }
        }
    },
    update() {
        this.langRelationStr = this["mainSite/getRelatedLangStr"];

    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/common.js